import React from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { Euro } from "lucide-react";
import PartnerPageHeader from "@/components/partners/PartnerPageHeader";
import PartnerBillingTab from "@/components/partners/PartnerBillingTab";
import { Skeleton } from "@/components/ui/skeleton";
import { usePartnerLeads } from "@/hooks/usePartnerLeads";
import { PartnerOutletContext } from "@/types/partnerPortal";

const PartnerBillingPage = () => {
  const { partnerId } = useParams<{ partnerId: string }>();
  const { partner } = useOutletContext<PartnerOutletContext>();
  const { leads, isLoading, error } = usePartnerLeads(partnerId);

  return (
    <div className="space-y-6">
      <PartnerPageHeader
        eyebrow="Διαφάνεια χρεώσεων"
        title="Χρεώσεις leads"
        description="Αναλυτική εικόνα των leads που χρεώνονται, ανά περίοδο και υπηρεσία."
      />
      {error && <div className="rounded-2xl border border-rose-200 bg-rose-50 p-4 text-sm font-medium text-rose-800">{error}</div>}
      {isLoading ? (
        <div className="space-y-4"><div className="grid grid-cols-2 gap-3 lg:grid-cols-3"><Skeleton className="h-32 rounded-2xl" /><Skeleton className="h-32 rounded-2xl" /><Skeleton className="col-span-2 h-32 rounded-2xl lg:col-span-1" /></div><Skeleton className="h-80 rounded-2xl" /></div>
      ) : (
        <PartnerBillingTab leads={leads} partnerName={partner.name} />
      )}
      <div className="flex items-start gap-3 rounded-2xl border border-sky-200 bg-sky-50 p-4 text-sm leading-6 text-sky-900">
        <Euro className="mt-0.5 h-5 w-5 shrink-0" />
        <p><strong>Σημείωση:</strong> Η εικόνα υπολογίζεται από τα leads που έχουν καταχωρηθεί στην πλατφόρμα. Δεν αντικαθιστά παραστατικό ή τελικό λογιστικό υπόλοιπο.</p>
      </div>
    </div>
  );
};

export default PartnerBillingPage;
